/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import ClassNames from 'classnames';
const { selectCurrentCountry } = Slices.profileSlice;
const { selectCountryValidations, getVariantConfig } = Slices.configSlice;
const { selectProductEntities } = Slices.productSlice;

import ViewCartButton from './ViewCartButton';
import CartItemCount from './CartItemCount';

import css from './index.module.scss';
import { useLocation } from '@reach/router';

function ProductAddToCart({
  popup = false,
  showIcon = true,
  imgSrc,
  isDesktop,
  productID,
  buttonText,
  to,
  onClick,
  selectedProduct,
  categoryID,
  price,
  showCustomizeProductDialog,
  forceDisableHide = false,
}) {
  const location = useLocation();
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const productsMap = useSelector(selectProductEntities);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const variationConfig = useSelector(getVariantConfig);
  const tempItems = useSelector((state) => state.tempCart);

  let finalPrice = 0;

  const locationSearch = new URLSearchParams(location.search);
  const isBundleItem = locationSearch.has('main_product') || false;
  const mainProductId = locationSearch.get('main_product');
  let stepId = locationSearch.get('step');

  const productCustomization = tempItems.data?.items?.find(
    (product) => product.id == (isBundleItem ? mainProductId : productID)
  );

  const productObj =
    productsMap[productID] ||
    productsMap[mainProductId]?.steps
      ?.find((step) => step.id == stepId)
      ?.options?.find((option) => option?.id == productID);
  const catProduct = (productObj?.categories?.length && productObj?.categories[0]) || 0;
  let buildCat = false;
  if (countryValidations.makeYourOwnPizza?.categoryId >= 1) {
    buildCat = countryValidations.makeYourOwnPizza?.categoryId === catProduct ? true : false;
  }

  let currentVariation, currentProductVariation;
  let variationArray = [-1, -1, -1];

  if (productObj?.bundleTypeId == 'bundle' && productObj?.typeId == 'simple') {
    stepId = productObj?.steps[0]?.id || 1;
  }

  if (!isBundleItem) {
    Object.values(productCustomization?.variants || {}).forEach((variant, index) => {
      variationArray[index] = variant;
    });

    currentProductVariation = productObj?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });

    currentProductVariation = productObj?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });
  } else {
    let stepInfo;
    if (
      productsMap[mainProductId]?.isBOGO ||
      productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
    ) {
      const paramsStepId = parseInt(locationSearch.get('step'));
      const optionId = parseInt(locationSearch.get('option'));

      let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
    } else {
      stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
    }

    const productInfo = stepInfo?.options?.find((option) => option?.id == productID);

    if (productCustomization?.bundle?.[stepId]?.[productID]?.variants) {
      Object.values(productCustomization?.bundle?.[stepId]?.[productID]?.variants).forEach(
        (variant, index) => {
          variationArray[index] = variant;
        }
      );
    } else {
      Object.values(productInfo?.variants || {}).forEach((variant, index) => {
        const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
        if (selectedOption) {
          variationArray[index] = selectedOption?.id;
        }
      });
    }

    if ((productInfo?.items?.length || 0) < 2 || productInfo?.typeId == 'simple') {
      currentProductVariation = productInfo?.items?.[0] || productInfo;
      if (productsMap[mainProductId]?.isBOGO) {
        currentProductVariation = productsMap[productInfo?.id]?.items?.[0];
      }
    } else {
      currentProductVariation = productInfo?.items?.find((item) => {
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          if (item[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });
    }
  }

  if (!currentProductVariation?.steps?.[0]?.options) {
    currentProductVariation = productsMap[productID]?.items?.find(
      (item) => item?.id == currentProductVariation?.id
    );
  }

  if (
    productsMap[productID]?.bundleTypeId == 'bundle' &&
    productsMap[productID]?.typeId == 'simple'
  ) {
    currentProductVariation = productsMap[productID];
  }

  let disableButton = false;
  if (buildCat && !forceDisableHide) {
    console.log('111111111');
    const itmList = Object.values(productCustomization?.items || {});
    if (Array.isArray(itmList)) {
      // debugger;
      if (itmList?.length <= 1) {
        disableButton = true;
      } else {
        const abs = itmList?.forEach((itm) => {
          if (Object.keys(itm).length === 0) {
            disableButton = true;
          }
        });
      }
    }
  } else if (
    currentProductVariation?.bundleTypeId == 'bundle' &&
    currentProductVariation?.typeId == 'simple'
  ) {
    console.log('22222222222');
    let total = 0;
    for (let option of Object.values(productCustomization['bundle']?.[stepId] || {})) {
      total += option?.qty || 0;
    }
    const simpleBundleStep = currentProductVariation?.steps?.find((s) => s?.id == stepId);

    if ((simpleBundleStep?.minimum || 0) > total) {
      disableButton = true;
    }
  }

  // add base price -
  finalPrice +=
    currentProductVariation?.price >= 0
      ? currentProductVariation?.price
      : currentProductVariation?.specialPrice || currentProductVariation?.originalPrice || 0;
  // add price for additional items such as sauce and toppings
  if (isBundleItem) {
    for (let step of currentProductVariation?.steps || []) {
      for (let option of step?.options || []) {
        if (option?.subOptions) {
          finalPrice +=
            option?.subOptions[
              productCustomization?.bundle?.[stepId]?.[productID]?.items?.[step.id]?.[option.id]?.[
                'qty'
              ] - 1
            ]?.price || 0;
        } else {
          if (
            productCustomization?.bundle?.[stepId]?.[productID]?.items?.[step.id]?.[option.id]?.[
              'qty'
            ]
          ) {
            finalPrice +=
              (option?.price || 0) *
              Number(
                productCustomization?.bundle?.[stepId]?.[productID]?.items?.[step.id]?.[
                  option.id
                ]?.['qty'] || 0
              );
          }
        }
      }
    }
  } else {
    for (let step of currentProductVariation?.steps || []) {
      for (let option of step?.options || []) {
        if (option?.subOptions) {
          finalPrice +=
            option?.subOptions[productCustomization?.items?.[step.id]?.[option.id]?.['qty'] - 1]
              ?.price || 0;
        } else {
          if (productCustomization?.items?.[step.id]?.[option.id]?.['qty']) {
            finalPrice +=
              (option?.price || 0) *
              Number(productCustomization?.items?.[step.id]?.[option.id]?.['qty'] || 0);
          } else if (productCustomization?.['bundle']?.[step.id]?.[option.id]?.['qty']) {
            finalPrice +=
              (option?.price || 0) *
              Number(productCustomization?.['bundle']?.[step.id]?.[option.id]?.['qty'] || 0);
          }
        }
      }
    }
  }

  if (!finalPrice && productObj?.bundleTypeId == 'simple' && productObj?.typeId == 'simple') {
    finalPrice =
      productObj?.price >= 0
        ? productObj?.price
        : productObj?.specialPrice || productObj?.originalPrice || 0;
  }

  return (
    <div
      className={ClassNames(css.root, {
        [css.noPadding]: popup,
        [css.buttonWrapper]: isDesktop,
        [css.noShadow]: showCustomizeProductDialog > 0,
        [css.disable]: disableButton,
      })}
    >
      {!isDesktop && (showCustomizeProductDialog === 0 || !showCustomizeProductDialog) && (
        <CartItemCount src={imgSrc} count={1} />
      )}
      <ViewCartButton
        isBundleItem={isBundleItem}
        buttonText={buttonText}
        to={to}
        showIcon={showIcon}
        onClick={onClick}
        amount={showCustomizeProductDialog ? price : finalPrice}
        currency={countryValidations?.currency}
        selectedProduct={selectedProduct}
        categoryID={categoryID}
        productID={productID}
        showCustomizeProductDialog={showCustomizeProductDialog}
        imgSrc={imgSrc}
        isDesktop={isDesktop}
      />
    </div>
  );
}
export default ProductAddToCart;
